module.exports = __webpack_public_path__ + "media/assets/icons/tree-stars-306866a029609e840ae7c3607bb27067.svg";